import React from 'react';
import { Icon } from './Icon.js';
export const IconCircleCaretDownFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M9,1C4.589,1,1,4.589,1,9s3.589,8,8,8,8-3.589,8-8S13.411,1,9,1Zm2.643,7.17l-2.022,2.987c-.297,.439-.945,.439-1.242,0l-2.022-2.987c-.337-.498,.02-1.17,.621-1.17h4.044c.601,0,.958,.672,.621,1.17Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconCircleCaretDownFill18.js.map